
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public-profile/[id]",
      function () {
        return require("private-next-pages/public-profile/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public-profile/[id]"])
      });
    }
  